import HTTPService from '../HTTPService'

class ChatFirst {
  createNewMessage (companySlug, payload) {
    return HTTPService.post(`company/${companySlug}/chat-first`, {
      transport_slug: payload.transport_slug,
      phone: payload.phone,
      body: payload.body,
      template_name: payload.template_name,
      variables: payload.variables
    })
  }

  getChannels (companySlug) {
    return HTTPService.get(`company/${companySlug}/chat-first/transport`)
  }
}

export default new ChatFirst()
